import React, { Component } from "react";
import { CloseBtn, ReplayBtn } from "./Buttons";

class ResultMenu extends Component {
  render() {
    return (
      <>
        <div
          className="result-menu d-flex justify-content-end mt-3"
          id="result-menu-overlay"
        >
          <ReplayBtn onClick={this.props.replayClick} />
          <CloseBtn />
        </div>
      </>
    );
  }
}

export default ResultMenu;
